
import FacebookSettingsCard from '@/components/facebook/FacebookSettingsCard.vue';
import FacebookLoginCard from '@/components/facebook/FacebookLoginCard.vue';
import PlatformLatestPostsCard from '@/components/social/PlatformLatestPostsCard.vue';
import { SOCIAL_PLATFORMS_METADATA } from '@/constants';
import { ProjectViewMixin } from '@/mixins/ProjectViewMixin';
import { Bot, FacebookMessengerPlatformData, SupportedPlatform } from 'ignite360-core';
import _merge from 'lodash.merge';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'project-social-platform-facebook',
  components: {
    FacebookLoginCard,
    FacebookSettingsCard,
    PlatformLatestPostsCard,
  },
})
export default class ProjectSocialPlatformFacebook extends mixins(ProjectViewMixin) {
  readonly facebookPlatform = SupportedPlatform.FacebookMessenger;

  get isPlatformConnected(): boolean {
    const meta = SOCIAL_PLATFORMS_METADATA.find(
      (m) => m.value === SupportedPlatform.FacebookMessenger,
    );
    return !!this.bot && !!meta?.isConnected?.(this.bot);
  }

  onConnect(data: Partial<FacebookMessengerPlatformData>) {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.FacebookMessenger]: data,
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }

  onDisconnect() {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.FacebookMessenger]: {
          pageId: '',
          pageName: '',
          pageAccessToken: '',
        },
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }
}
